export const homeProps = {
  basename: "/plataforma/inicio",
};
